"use client";

import { useState, useRef, useEffect, useCallback } from "react";
import profile_img from "../../assets/imgs/me.png";
import GlassSurface from "../../../v2/components/common/GlassSurface";

export default function StickyNote({
  title,
  content,
  width = 309,
}) {
  const [position, setPosition] = useState({ x: 10, y: 20 }
  );
  const [isDragging, setIsDragging] = useState(false);

  const dragOffset = useRef({ x: 0, y: 0 });
  const noteRef = useRef(null);

  const handleMouseDown = useCallback((e) => {
    if (e.button !== 0) return;

    e.preventDefault();
    e.stopPropagation();

    const rect = noteRef.current?.getBoundingClientRect();
    if (rect) {
      dragOffset.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    }

    setIsDragging(true);
  }, []);

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDragging) return;

      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    },
    [isDragging]
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  return (
    

    <div
      ref={noteRef}
      className="fixed z-30 select-none p-[20px]"
      style={{
        width,
        left: position.x,
        top: position.y,
        borderRadius: 6,
        cursor: isDragging ? "grabbing" : "grab",
        transition: isDragging ? "none" : "transform 0.2s ease",
        transform: isDragging ? "scale(1.02)" : "scale(1)",
      }}
      onMouseDown={handleMouseDown}
      >
        <GlassSurface
          width={width}
            height={500}
            borderRadius={35}
            backgroundOpacity={0.14}
            blur={9}
            displace={.5}
            borderWidth={0}
            distortionScale={90}
            className="shadow-[0_30px_80px_rgba(0,0,0,.4)]"
    >
      <div className="flex flex-col gap-1">
        {/* Title */}
        <p
          className="text-[20px] leading-[1.3] italic"
          style={{
            fontFamily: '"Instrument Serif", "Times New Roman", serif',
            fontWeight: 400,
            color: "#000",
          }}
          >
          {title}
        </p>

        {/* Content */}
        <p
          className="text-[45px] italic leading-none text-justify font-instrument"
          // style={{
            //   fontFamily:
            //     '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
            //   fontWeight: 400,
            //   color: "#444",
            // }}
            >
          {content}
        </p>

        {/* Image */}
        <img
          src={profile_img}
          alt="Profile"
          className="w-full h-[400px]  rounded-md"
          draggable={false}
          />
      </div>
  </GlassSurface>
    </div>
  );
}